import { Badge } from "@/components/ui/badge";
import { Mailbox } from "lucide-react";

const MAP = {
  ready: ["Postcard queued", "bg-slate-100 text-slate-700"],
  printing: ["Printing", "bg-amber-100 text-amber-800"],
  processed_for_delivery: ["In the mail", "bg-sky-100 text-sky-800"],
  entered_mail_stream: ["In the mail", "bg-sky-100 text-sky-800"],
  out_for_delivery: ["Out for delivery", "bg-indigo-100 text-indigo-800"],
  completed: ["Delivered", "bg-emerald-100 text-emerald-800"],
  delivered: ["Delivered", "bg-emerald-100 text-emerald-800"],
  returned_to_sender: ["Returned", "bg-red-100 text-red-700"],
  cancelled: ["Mail cancelled", "bg-slate-100 text-slate-500"],
};

export const mailLabel = (s) => (MAP[s] || [s ? s.replace(/_/g, " ") : ""])[0];

export const MailBadge = ({ p, testId }) => {
  const s = p?.mail_status;
  if (!s && !p?.mail_response_at && !p?.mail_address_flag) return null;
  if (p?.mail_address_flag && !s) {
    return (
      <Badge className="gap-1 border-0 bg-red-100 text-red-700" data-testid={testId} title={(p.mail_verification?.errors || []).join("; ")}>
        <Mailbox className="h-3 w-3" /> Address needs fixing
      </Badge>
    );
  }
  if (p?.mail_response_at) {
    return (
      <Badge className="gap-1 border-0 bg-emerald-600 text-white" data-testid={testId} title={`Responded to postcard${p.callback_phone ? " · callback requested" : ""}`}>
        <Mailbox className="h-3 w-3" /> {p.callback_phone ? "Callback requested" : "Responded to mail"}
      </Badge>
    );
  }
  const [label, cls] = MAP[s] || [s.replace(/_/g, " "), "bg-slate-100 text-slate-700"];
  return (
    <Badge className={`gap-1 border-0 capitalize ${cls}`} data-testid={testId} title="Postcard status (PostGrid)">
      <Mailbox className="h-3 w-3" /> {label}
    </Badge>
  );
};
